import NavigationBar from "../comps/NavigationBar/NavigationBar";
import Footer from "../comps/Footer/Footer";
import ContentCard from "../comps/ContentCard/ContentCard";

export default function Model() {
  return (
    <div className="general-background">
      <NavigationBar />
      <div className="main-container">
        <p className="title">Model</p>
        <ContentCard
          content={` 
            <p>
            BioRocket aims to accurately excavate eCISs within prokaryotic genomes. To achieve this objective, we employ a comprehensive array of models to systematically and quantitatively comprehend the challenges encountered and propel the project forward. Compared to the traditional search methods that solely relied on sequence similarity, we are now, for the first time, utilizing machine learning to process sequence information and incorporating structural information into the mining process.
            </p>
            <br/>
            <img
            src='https://static.igem.wiki/teams/4826/wiki/model-figure1-new.png'
            alt='Figure 1. BioRocket's model ("n" represents the number of candidate species)'
            class='content-figure'
            />
            <p class='content-legend'>
            Figure 1. BioRocket's model ("n" represents the number of candidate species)
            </p>
            <br/>
            <b>1. Data Collection:</b>
            <p>
            We obtained eCIS positive and negative data and defined the search space. The detailed collection process is shown in the PDF document below.
            </p>
            <br/>
            <b>2. eCIS Mining:</b>
            <p>
            To more accurately mine eCISs, we simultaneously consider both the protein's sequence and structural information.
            </p>
            <br/>
            <p>
            <b>2.1 Sequence-based mining: </b> By fine-tuning pre-trained protein language models, we can effectively uncover various homologous proteins of eCISs from input unknown protein sequences. Additionally, we have developed a search methodology that utilizes over ten models to comprehensively identify complete eCISs and determine their boundaries.
            </p>
            <br/>
            <p>
            <b>2.2 Structure-based mining: </b> The functionality of proteins is ultimately determined by their 3D folding. Therefore, building upon Sequence-based mining, we have computed the key structures of eCIS candidates at high throughput using artificial intelligence structure prediction algorithms. We then compare these structures with those resolved by cryo-electron microscopy, further enhancing the accuracy of our mining efforts.
            </p>
            <br/>
            <p>
            We have organized the entire modeling process into a "Methods" document. Scroll in the preview below or download the PDF.
            </p>
            <br/>
            <iframe width="100%" height="1000px" src="https://static.igem.wiki/teams/4826/wiki/model-methods.pdf"></iframe>
            `}
        />
      </div>
      <Footer />
    </div>
  );
}
